import React, { Component } from "react";
import "react-block-ui/style.css";
import LoadingIndicator from "../Components/LoadingIndicator/LoadingIndicator";
import ReportsService from "../utils/ReportsService";
import { Link } from "react-router-dom";
import Pagination from "../Shared/pagination";

const StatTable = props => {
  const { title, data } = props;

  const rows = data.map((value, index) => (
    <tr key={index}>
      <td>
        {value["sender"].first_name} {value["sender"].last_name}
      </td>
      <td>{value["status"]}</td>
      <td>
        {value["deal_ids"].map(deal_id => (
          <Link
            to={`/m1/deals/${deal_id}`}
          >
            Deal #{deal_id}{" , "}
          </Link>
        ))}
      </td>
    </tr>
  ));
  return (
    <div
      style={{
        padding: 20,
        margin: 10,
        background: "#fefefe",
        border: "1px solid #ccc"
      }}
    >
      <h4 style={{ marginTop: 0 }}>{title}</h4>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Sender</th>
            <th>Status</th>
            <th>Deals</th>
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
    </div>
  );
};

class ReportingBulkMessages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      currentPage: 1,
      totalPages: 1,
      per: 20
    };
  }

  onPageChange = currentPage => {
    this.setState({ currentPage: currentPage }, () => this.fetchItems());
  };

  componentDidMount() {
    this.setState({ loadingInProgress: true }, () => {
      this.fetchItems();
    });
  }

  fetchItems() {
    this.setState({ loadingInProgress: true });
    ReportsService.bulkMessages({
      page: this.state.currentPage,
      per: this.state.per
    }).then(data => {
      this.setState({
        loadingInProgress: false,
        data: data,
        totalPages: data.total_pages || 1
      });
    });
  }

  render() {
    console.log("this.state.data", this.state.data);
    if (!this.state.data) return null;

    return (
      <LoadingIndicator loadingInProgress={this.state.loadingInProgress}>
        {this.state.totalPages > 1 &&
        <Pagination
          currentPage={this.state.currentPage}
          totalPages={this.state.totalPages}
          onChange={this.onPageChange}
        />}
        <StatTable
          title="Bulk Messages Reporting"
          data={this.state.data.result}
        ></StatTable>
      </LoadingIndicator>
    );
  }
}
export default ReportingBulkMessages;
